// import html from "./pc.html";

const PersonalCabinet = () => {  

    return (
        <div class="wf-section">
            <p align="center"><iframe title="Личный кабинет" src='./pc.html' width={780} height={600} frameborder="yes"></iframe></p>
        </div>
    )
}  

export default PersonalCabinet;
